import Tokenomics from "./tokenomics";

export default Tokenomics;
